

import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { componentHead } from "../../../../../config/constant";
import { NavLink } from "react-router-dom";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';
import clsx from "clsx";


export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, details, onEdit, onDelete, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={componentHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(componentHead, 1) }}><span style={{ width: getColumnWidth(componentHead, 1) }}>{data.componentType}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Component Type', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Component Type', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
        </>
    )
}